import React from "react"

import Header from "./components/Header"
// import Footer from "./components/Footer"
import Tiles from "./components/Tiles"

import StyledStrategyMain from "./styles"

const StrategyMain = () => {
  return (
    <StyledStrategyMain>
      <Header />
      <Tiles />
      {/* <Footer /> */}
    </StyledStrategyMain>
  )
}

export default StrategyMain
